import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';

interface containerInterface {
  error: boolean;
}

export const Container = styled.div<containerInterface>`
  
  ${props =>
    props.error &&
    css`
      background-color: transparent;
      border-color: #c53030;
    `}
`;

export const Error = styled(Tooltip)`
  display: flex;
  position: absolute;
  background-color: transparent;
  height: 40px;
  align-items: center;
  margin-left: -40px;
  max-width: 40px;
  padding-left: 10px;

  svg {
    margin: 0;
  }

  span {
    border: none;
    background: #c53030;
    color: #fff;
    margin-left: 160px;

    &::before {
      border-color: none;
    }
  }
`;
